import { useState, useEffect, useContext } from 'react';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { getThreadHot, IThreadHotItem } from '@/api/thread';
import { getDetailUrl } from '@/constants/url';
import Styles from './index.module.scss';
import { StoreContext, namespace } from '@/context';
import { ThreadDetailCtx } from '@/context/threadDetail';
import { getThreadDetailInfo } from '@/api/detail';

const ThreadHotPost = () => {
  const [data, setData] = useState<IThreadHotItem[] | []>([]);
  const t = useTranslations();

  const { state } = useContext(StoreContext);
  const { track, TRACK_EVENTS, extractThreadTags } = state[namespace.app].sensors || {};

  const threadDetail = useContext(ThreadDetailCtx);

  useEffect(()=>{
    getThreadHot().then(res=>setData(res));
  }, [])

  return data.length > 0 ? (
    <div className={Styles.root}>
      <h5 className={Styles.title}>{t("thread_hot_title")}</h5>
      <ul className={Styles.list}>
        {
          data.map(({tid, title}: IThreadHotItem)=>(
            <li key={tid}>
              <Link
                target='_blank'
                href={getDetailUrl(tid)}
                className={Styles.post}
                onClick={async () => {
                    try {
                      // TODO：后端新增字段author.id，去除接口请求逻辑
                      const { item } = await getThreadDetailInfo(false, tid)
                      track?.(TRACK_EVENTS?.[namespace.detail].threadEntryClick.name, {
                        thread_tid: threadDetail?.tid,
                        thread_name: threadDetail?.subject,
                        account_slug: threadDetail?.author?.id,
                        thread_tag_name: extractThreadTags?.(threadDetail?.forum_types),
                        list_name: (threadDetail?.forum_types || [])[0]?.name || t('btn_home'),
                        click_thread_tid: tid,
                        click_thread_name: title,
                        click_account_slug: item?.author?.id,
                        is_featured: !!threadDetail?.digest,
                        position: 'HotPosts',
                      }, namespace.detail);
                    } catch (e) {
                      // ignore error
                    }
                }}
              >
              {title}
              </Link>
            </li>
          ))
        }
      </ul>
    </div>
  ) : null;
}

export default ThreadHotPost;